export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/typographic.f068f17.svg";